import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { IconSC, IconSizes } from 'atoms/Icon'
import { TextBoxSC } from 'atoms/TextBox'
import { COLOR } from 'vars/color'
import { CORNERS } from 'vars/corners'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const InteractionLayoutSC = styled.div<{ selected?: boolean }>`
  display: ${({ selected }) => (selected ? 'flex' : 'none')};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: var(${CORNERS.CORNERS_ROUND});
  background-color: var(${COLOR.SURFACE_OPACITY_DARK_40});
  align-items: center;
  justify-content: center;

  ${IconSC} {
    font: ${IconSizes.xxMedium};
    display: none;

    &:last-child {
      display: block;
    }
  }
`

export const AvatarProfileBlockRootSC = styled.div<{
  dimmed?: boolean
}>`
  display: inline-flex;
  border-radius: var(${CORNERS.CORNERS_ROUND});
  transition: opacity 0.2s ease;
  opacity: ${({ dimmed }) => (dimmed ? 0.42 : 1)};
`

export const AvatarProfileWrapper = styled.div`
  position: relative;
  width: max-content;
  height: max-content;
  border-radius: var(${CORNERS.CORNERS_ROUND});
  cursor: pointer;

  &:hover {
    ${InteractionLayoutSC} {
      display: flex;

      ${IconSC} {
        &:first-child {
          display: block;
        }
        &:last-child {
          display: none;
        }
      }
    }
  }
`

export const AddButtonWrapper = styled.div`
  position: relative;
  --buttonSize: 116px;
  --buttonSmallSize: 96px;

  ${ButtonSC} {
    width: var(--buttonSmallSize);
    height: var(--buttonSmallSize);

    ${MEDIA.MIN_600} {
      width: var(--buttonSize);
      height: var(--buttonSize);
    }
  }

  > ${IconSC} {
    z-index: 3;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 78px;
    height: 23px;
    transition: filter 0.2s ease;

    ${MEDIA.MIN_600} {
      font-size: 91px;
      height: 27px;
    }
  }

  &:hover > ${IconSC} {
    filter: brightness(0.7);
  }
`

export const TextWrapperSC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(${FIXED_INDENTS.INDENT_10});
  transition: opacity 0.2s ease;

  ${TextBoxSC} {
    transition: opacity 0.2s ease;
  }
`
